<script lang="ts">
import type { TIconValue } from '@/utils/helper-objects'
import { pascalCase } from 'change-case'
import { type PropType, defineComponent } from 'vue'

import IconAccordionArrow from './IconAccordionArrow.vue'
import IconAccountManage from './IconAccountManage.vue'
import IconAddCard from './IconAddCard.vue'
import IconArrowDown from './IconArrowDown.vue'
import IconArrowDownThin from './IconArrowDownThin.vue'
import IconArrowLeft from './IconArrowLeft.vue'
import IconArrowRight from './IconArrowRight.vue'
import IconBalance from './IconBalance.vue'
import IconBell from './IconBell.vue'
import IconBuilding from './IconBuilding.vue'
import IconCalendar from './IconCalendar.vue'
import IconCalendarStar from './IconCalendarStar.vue'
import IconCard from './IconCard.vue'
import IconCardPack from './IconCardPack.vue'
import IconCash from './IconCash.vue'
import IconCashNote from './IconCashNote.vue'
import IconChart from './IconChart.vue'
import IconCheck from './IconCheck.vue'
import IconChevronDown from './IconChevronDown.vue'
import IconClock from './IconClock.vue'
import IconClover from './IconClover.vue'
import IconCloverOutlined from './IconCloverOutlined.vue'
import IconCrown from './IconCrown.vue'
import IconDiamond from './IconDiamond.vue'
import IconDiversity from './IconDiversity.vue'
import IconDreamCars from './IconDreamCars.vue'
import IconEdit from './IconEdit.vue'
import IconEntries from './IconEntries.vue'
import IconEnvelope from './IconEnvelope.vue'
import IconError from './IconError.vue'
import IconErrorGoogle from './IconErrorGoogle.vue'
import IconEventAvailable from './IconEventAvailable.vue'
import IconExperiences from './IconExperiences.vue'
import IconFootball from './IconFootball.vue'
import IconGetAways from './IconGetAways.vue'
import IconGift from './IconGift.vue'
import IconHandHeart from './IconHandHeart.vue'
import IconHome from './IconHome.vue'
import IconInformation from './IconInformation.vue'
import IconLeaderBoard from './IconLeaderBoard.vue'
import IconLightening from './IconLightening.vue'
import IconLighteningOutlined from './IconLighteningOutlined.vue'
import IconLuxuryItem from './IconLuxuryItem.vue'
import IconMastercard from './IconMastercard.vue'
import IconMegaphone from './IconMegaphone.vue'
import IconMember from './IconMember.vue'
import IconMemberPrizes from './IconMemberPrizes.vue'
import IconMembersPrizes from './IconMembersPrizes.vue'
import IconMembersZone from './IconMembersZone.vue'
import IconMessage from './IconMessage.vue'
import IconMileage from './IconMileage.vue'
import IconMobileTablet from './IconMobileTablet.vue'
import IconMoneyBag from './IconMoneyBag.vue'
import IconMoneyBagFill from './IconMoneyBagFill.vue'
import IconMoneyBox from './IconMoneyBox.vue'
import IconPacks from './IconPacks.vue'
import IconPadlock from './IconPadlock.vue'
import IconPlay from './IconPlay.vue'
import IconPresent from './IconPresent.vue'
import IconPrize from './IconPrize.vue'
import IconPrizeSack from './IconPrizeSack.vue'
import IconProfile from './IconProfile.vue'
import IconQuestion from './IconQuestion.vue'
import IconReload from './IconReload.vue'
import IconRibbon from './IconRibbon.vue'
import IconSetting from './IconSetting.vue'
import IconShare from './IconShare.vue'
import IconSignal from './IconSignal.vue'
import IconSlotMachine from './IconSlotMachine.vue'
import IconSocials from './IconSocials.vue'
import IconSpaceship from './IconSpaceship.vue'
import IconSpeakerOff from './IconSpeakerOff.vue'
import IconSpeakerOn from './IconSpeakerOn.vue'
import IconStar from './IconStar.vue'
import IconStarOutlined from './IconStarOutlined.vue'
import IconStarRefresh from './IconStarRefresh.vue'
import IconStarTick from './IconStarTick.vue'
import IconSupport from './IconSupport.vue'
import IconTechnology from './IconTechnology.vue'
import IconTelephone from './IconTelephone.vue'
import IconTicket from './IconTicket.vue'
import IconTicketStar from './IconTicketStar.vue'
import IconTicketTick from './IconTicketTick.vue'
import IconTimer from './IconTimer.vue'
import IconTimes from './IconTimes.vue'
import IconTransfer from './IconTransfer.vue'
import IconTransmission from './IconTransmission.vue'
import IconTrophy from './IconTrophy.vue'
import IconTv from './IconTv.vue'
import IconVisa from './IconVisa.vue'
import IconVodafoneDiamond from './IconVodafoneDiamond.vue'
import IconVodafoneSignal from './IconVodafoneSignal.vue'
import IconVodafoneTicket from './IconVodafoneTicket.vue'
import IconWatch from './IconWatch.vue'
import IconWhatsapp from './IconWhatsapp.vue'
import IconWinners from './IconWinners.vue'
import IconYearModel from './IconYearModel.vue'

/**
 * An general icon component listing all icons available.
 *
 * @see helper-objects::Icons
 */
export default defineComponent({
  components: {
    IconAccordionArrow,
    IconAccountManage,
    IconAddCard,
    IconArrowDown,
    IconArrowDownThin,
    IconArrowLeft,
    IconArrowRight,
    IconBalance,
    IconBell,
    IconBuilding,
    IconCalendar,
    IconCalendarStar,
    IconCard,
    IconCardPack,
    IconCash,
    IconCashNote,
    IconChart,
    IconCheck,
    IconChevronDown,
    IconClock,
    IconClover,
    IconCloverOutlined,
    IconCrown,
    IconDiamond,
    IconDiversity,
    IconDreamCars,
    IconEdit,
    IconEntries,
    IconEnvelope,
    IconError,
    IconErrorGoogle,
    IconEventAvailable,
    IconExperiences,
    IconFootball,
    IconGetAways,
    IconGift,
    IconHandHeart,
    IconHome,
    IconInformation,
    IconLeaderBoard,
    IconLightening,
    IconLighteningOutlined,
    IconLuxuryItem,
    IconMastercard,
    IconMegaphone,
    IconMember,
    IconMemberPrizes,
    IconMembersPrizes,
    IconMembersZone,
    IconMessage,
    IconMileage,
    IconMobileTablet,
    IconMoneyBag,
    IconMoneyBagFill,
    IconMoneyBox,
    IconPacks,
    IconPadlock,
    IconPlay,
    IconPresent,
    IconPrize,
    IconPrizeSack,
    IconProfile,
    IconQuestion,
    IconReload,
    IconRibbon,
    IconSetting,
    IconShare,
    IconSignal,
    IconSlotMachine,
    IconSocials,
    IconSpaceship,
    IconSpeakerOff,
    IconSpeakerOn,
    IconStarOutlined,
    IconStar,
    IconStarRefresh,
    IconStarTick,
    IconSupport,
    IconTechnology,
    IconTelephone,
    IconTicket,
    IconTicketStar,
    IconTicketTick,
    IconTimer,
    IconTimes,
    IconTransfer,
    IconTransmission,
    IconTrophy,
    IconTv,
    IconVisa,
    IconVodafoneDiamond,
    IconVodafoneSignal,
    IconVodafoneTicket,
    IconWatch,
    IconWhatsapp,
    IconWinners,
    IconYearModel,
  },
  inheritAttrs: false,
  props: {
    /**
     * The name of the icon to display
     */
    icon: {
      type: String as PropType<TIconValue>,
      required: true,
    },
    /**
     * Size of the icon.
     *
     * xs: h-4 w-4
     * sm: h-6 w-6
     * md: h-8 w-8
     * lg: h-12 w-12
     */
    size: {
      type: String,
      default: 'sm',
    },
    /**
     * Aria label.
     */
    label: {
      type: String,
    },
  },
  setup() {
    return {
      pascalCase,
    }
  },
  computed: {
    iconName() {
      return 'Icon' + pascalCase(this.icon.replace(/Icon|[^a-zA-Z0-9]/g, ''))
    },
    iconSize() {
      switch (this.size) {
        case '2xs':
          return 'h-3 w-3'

        case 'xs':
          return 'h-4 w-4'

        default:
        case 'sm':
          return 'h-5 w-5'

        case 'md':
          return 'text-[2.5rem] h-8 w-8'

        case 'lg':
          return 'h-12 w-12'
      }
    },
  },
})
</script>

<template>
  <component
    :is="iconName"
    :class="[$attrs.class, iconSize, iconName]"
    class="box-content inline-flex items-center justify-center focus:outline-none"
    role="presentation"
  />
</template>
